<script setup>
import { ref, watch } from 'vue'
import { useMouseInElement } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
// props适配图片列表

defineProps({
    imageList: {
        type: Array,
        default: () => []
    }
})

// 图片列表
// const imageList = [
//     "https://yanxuan-item.nosdn.127.net/d917c92e663c5ed0bb577c7ded73e4ec.png",
//     "https://yanxuan-item.nosdn.127.net/e801b9572f0b0c02a52952b01adab967.jpg",
//     "https://yanxuan-item.nosdn.127.net/b52c447ad472d51adbdde1a83f550ac2.jpg",
//     "https://yanxuan-item.nosdn.127.net/f93243224dc37674dfca5874fe089c60.jpg",
//     "https://yanxuan-item.nosdn.127.net/f881cfe7de9a576aaeea6ee0d1d24823.jpg"
// ]

// 1.小图切换大图显示
const activeIndex = ref(0)

const enterhandler = (i) => {
    activeIndex.value = i
}

// 2. 获取鼠标相对位置
const target = ref(null)
const { elementX, elementY, isOutside } = useMouseInElement(target)

// 3. 控制滑块跟随鼠标移动（监听elementX/Y变化，一旦变化 重新设置left/top）
const left = ref(0)
const top = ref(0)

const positionX = ref(0)
const positionY = ref(0)
watch([elementX, elementY, isOutside], () => {
    // console.log('xy变化了');
    // 如果鼠标没有移入到盒子里面 直接不执行后面的逻辑
    if (isOutside.value) return
    // console.log('后续逻辑执行了');
    // 有效范围内控制滑块距离
    // 横向
    if (elementX.value > 100 && elementX.value < 300) {
        left.value = elementX.value - 100
    }
    // 纵向
    if (elementY.value > 100 && elementY.value < 300) {
        top.value = elementY.value - 100
    }

    // 处理边界
    if (elementX.value > 300) { left.value = 200 }
    if (elementX.value < 100) { left.value = 0 }

    if (elementY.value > 300) { top.value = 200 }
    if (elementY.value < 100) { top.value = 0 }

    // 控制大图的显示
    positionX.value = -left.value * 2
    positionY.value = -top.value * 2

})

const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   
   
})
const isMp4=(url) =>{
    return url ? url.toLowerCase().endsWith(".mp4") : false;
}
</script>


<template>
    <div >
       
        <!-- {{ elementX }}, {{ elementY }}, {{ isOutside }} -->
        <div class="goods-image">
            
            <!-- 左侧大图-->
            <div class="middle" ref="target">
            <!-- 判断是否是 MP4 文件 -->
                <video v-if="isMp4(imageList[activeIndex])" controls style="width: 397px; height: 397px;">
                <source :src="imageList[activeIndex]" type="video/mp4">
                {{ $t('setup497') }}
                </video>

                <!-- 如果不是 MP4 文件，则显示图片 -->
                <img v-else :src="imageList[activeIndex]" alt="" />

                <!-- 蒙层小滑块 -->
                <div class="layer" v-show="!isOutside&&isMobile==false" :style="{ left: `${left}px`, top: `${top}px` }"></div>
            </div>
        
            <!-- 放大镜大图 -->
            <div class="large" v-show="!isOutside && isMobile == false">
                <div style="position: relative;width: 400px;height: 400px;overflow: hidden;">
                    <img :src="imageList[activeIndex]" alt=""
                        :style="[{ position: 'absolute', left: `${positionX}px`, top: `${positionY}px`, width: '800px', height: '800px', maxWidth: '200%', maxHeight: '200%', objectFit: 'contain' }]" />
                </div>
            </div>
        </div>
        <div>
            <!-- 小图列表 -->
            <ul class="small">
                
                <li v-for="(img, i) in imageList.slice(0, 5)" :key="i" @mouseenter="enterhandler(i)"
                    :class="{ active: i === activeIndex }">
                
                    <video controls  v-if="isMp4(img)" style="width: 68px;height: 68px; border-radius: 6px;">
                        <source :src="img" type="video/mp4" >
                    </video>
                    <img v-else :src="img" alt="" />
                </li>
            </ul>
        </div>
    </div>
    
</template>

<style scoped lang="scss">
img {
    width: 100%;
    /* 或者指定宽度 */
    height: auto;
    /* 高度自动，保持原始比例 */
    object-fit: contain;
}

.goods-image {
    width: 397px;
    height: 413px;
    position: relative;
    display: flex;

    .middle {
        width: 397px;
        height: 397px;
        background: #F5F6F8;
        border-radius: 8px;
        img {
            width: 100%;
            border-radius: 8px;
        }
    }

    .large {
        position: absolute;
        top: 0;
        left: 397px;
        width: 397px;
        height: 397px;
        z-index: 500;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        background-repeat: no-repeat;
        // 背景图:盒子的大小 = 2:1  将来控制背景图的移动来实现放大的效果查看 background-position
        background-size: 800px 800px;
        background-color: #f8f8f8;
    }

    .layer {
        width: 200px;
        height: 200px;
        background: rgba(0, 0, 0, 0.2);
        // 绝对定位 然后跟随咱们鼠标控制left和top属性就可以让滑块移动起来
        left: 0;
        top: 0;
        position: absolute;
    }

   
}
.small {
    display: flex;
        list-style: none;
        width: 70px;
        margin-right: 20px;
        width: 392px;

        img {
            width: 100%;
            border-radius: 6px;
        }

        li {
            width: 70px;
            height: 70px;
            // margin-left: 12px;
            margin-bottom: 12px;
            border: 1px solid transparent; /* 预留边框空间 */
            cursor: pointer;

            &:hover,
            &.active {
                background: #F5F6F8;
                border-radius: 6px;
                border: 1px solid #FC3938;
            }
        }
    }
/* 响应式设计 */
@media (max-width: 768px) {
    .goods-image {
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;

    .middle {
        width: 100%;
        height: auto;
        background: #f5f5f5;

        img {
            width: 100%;
        }
    }

    .large {
        position: absolute;
        top: 0;
        left: 412px;
        width: 400px;
        height: 400px;
        z-index: 500;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        background-repeat: no-repeat;
        // 背景图:盒子的大小 = 2:1  将来控制背景图的移动来实现放大的效果查看 background-position
        background-size: 800px 800px;
        background-color: #f8f8f8;
    }

    .layer {
        width: 200px;
        height: 200px;
        background: rgba(0, 0, 0, 0.2);
        // 绝对定位 然后跟随咱们鼠标控制left和top属性就可以让滑块移动起来
        left: 0;
        top: 0;
        position: absolute;
    }

    .small {
        width: 100%;
        display: flex;
        img {
            width: 100%;
        }

        li {
            width: 68px;
            height: 68px;
            // margin-left: 12px;
            margin-bottom: 15px;
            cursor: pointer;

            &:hover,
            &.active {
                border: 2px solid $xtxColor;
            }
        }
    }
}
}
</style>